export default "__VITE_ASSET__Cm1GZ6ZF__"